import styled from "styled-components";

export const StyledContainerChips = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;
